import React from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faSignOutAlt,
  faUser,
  faSun,
  faMoon,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../context/AuthContext";
import { useShoppingContext } from "../context/ShoppingContext";
import Sidebar from "./Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import { useState } from "react";
import { useEffect } from "react";

const Header = () => {
  const { authenticatedUser, handleLogout } = useAuth();
  const [login, setLogin] = useState(false);
  const {
    showSidebar,
    setShowSidebar,
    setIsSignInActive,
    setAnimationClass,
    setIsButtonClicked,
    clearUserData,
    setGranjaActiva,
    setIsDarkMode,
    isDarkMode, // Extraemos el estado de dark mode
    toggleDarkMode, // Extraemos la función para alternar el modo,
  } = useShoppingContext();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setIsDarkMode(e.matches); // Update your app's dark mode state
    };
  
    mediaQuery.addEventListener('change', handleChange);
  
    // Set initial mode based on the system theme
    setIsDarkMode(mediaQuery.matches);
  
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [setIsDarkMode]);
  

  const shouldShowDarkMode = true;

  const handleButtonClick = () => {
    setIsButtonClicked(true);
    setTimeout(() => {
      setAnimationClass("show-form");
    }, 300);
  };

  return (
    <>
      <Sidebar />
      <header
        className={
          isDarkMode
            ? " header dark-mode-icon dark"
            : "header dark-mode-icon light"
        }
      >
        <nav className="header-nav">
          {authenticatedUser || location.pathname === "/create" ? (
            <div className="header-nav__space-between">
              <div
                className="faBars"
                onClick={() => {
                  setShowSidebar(!showSidebar);
                  setLogin(false);
                }}
              >
                <FontAwesomeIcon className={!isDarkMode ? "color-222" : ""} icon={faBars} />
              </div>

              <div className="flex gap-2">
                {login && !authenticatedUser ? (
                  <button
                    className={isDarkMode ? "header-btn header-login" : "header-btn light header-login " }
                    onClick={() => {
                      handleButtonClick();
                      setIsSignInActive(true);
                      navigate("/login");
                    }}
                  >
                    INICIAR SESIÓN
                  </button>
                ) : (
                  <p className="login-text">{authenticatedUser?.username}</p>
                )}

                <div className="user-buttons">
                  <div
                    onClick={() => setLogin(!login)}
                    className="faUser-circle"
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                </div>

                <FontAwesomeIcon
                  className="cerrar-sesion"
                  onClick={() => {
                    handleLogout();
                    clearUserData();
                    setGranjaActiva(null);
                    setShowSidebar(false);
                  }}
                  icon={faSignOutAlt}
                />
              </div>
            </div>
          ) : (
            ""
          )}

          {!authenticatedUser &&
            (location.pathname === "/" || location.pathname !== "/create") && (
              <div className="user-btns">
                <button
                  onClick={() => {
                    navigate("/create");
                    setLogin(false);
                    setIsButtonClicked(false);
                  }}
                  className={isDarkMode ? "header-btn header-start" : "header-btn light header-start"}
                >
                  CREAR GRANJA
                </button>
                <button
                  className="header-btn header-login"
                  onClick={() => {
                    navigate("/login");
                    setIsSignInActive(true);
                    handleButtonClick();
                  }}
                >
                  INICIAR SESIÓN
                </button>
              </div>
            )}
          {shouldShowDarkMode && (
            <div className="dark-mode-toggle" onClick={toggleDarkMode}>
              <FontAwesomeIcon
                icon={isDarkMode ? faSun : faMoon} // Cambia el icono dependiendo del estado
                className={
                  isDarkMode ? "dark-mode-icon dark" : "dark-mode-icon light"
                }
              />
            </div>
          )}
        </nav>
      </header>
    </>
  );
};

export default Header;
